module.exports = __webpack_public_path__ + "static/media/authentication.97536b88.svg";